import { render, staticRenderFns } from "./icon-comment.vue?vue&type=template&id=9a54fa28&scoped=true&"
var script = {}
import style0 from "./icon-comment.vue?vue&type=style&index=0&id=9a54fa28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a54fa28",
  null
  
)

export default component.exports